<div class="mb-80">
    <mapfre-header></mapfre-header>
</div>
<div class="enroll-data-not-match-main">
    <div class="enroll-not-match-content">
        <div class="enroll-data-not-match">
            <div class="enroll-oops-content">
                <div class="en-card-header">
                    <div class="en-title">{{"Oops, information does not match our records."}}</div>
                    <div class="en-desc">{{"Please make sure we've got your details right and try again."}}
                        <mapfre-tooltip additionalClasses="tool-tip-w tooltip-position" [placementLocation]="'auto'"
                            [fullTitle]="'Where can I find my information?'"
                            [description]="'Primary policyholder information, including policy number, can be found on the top left of either your last billing statement or renewal.'"
                            autoCloseProp="false" [trigger]="'manual'" imgPath="assets/img/images/policy-holder-invoice-info.svg"
                            imageHasBody="true">
                        </mapfre-tooltip>
                    </div>
                </div>
                <div class="enroll-details-list">
                    <ng-container *ngFor="let enrollData of enrollDetailsList">
                        <div class="enroll-details-list-item">
                            <span class="enroll-detail-label">{{ enrollData?.type}}</span><span class="enroll-detail-val dm-sans-medium">{{enrollData?.val}}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="enroll-oops-actions">
                <div class="bs-enroll-oops-btns">
                    <mapfre-button
                      (click)="cancel()"
                      additionalClasses="ghost secondary bs-oops-cancel mr-4" 
                    >{{ 'CANCEL' | translate }}
                  </mapfre-button>
                  <mapfre-button
                      (click)="tryAgain()"
                      additionalClasses="basic primary bs-oops-tryagain" 
                    > {{ 'Try again' | translate }}
                  </mapfre-button>
              </div>
            </div>
        </div>
    </div>
</div>
<app-confirm-modal *ngIf="displayConfirmModal" (closeConfirmModal)="onCloseConfirmModal()"></app-confirm-modal>